// the api that hooks rtkquery and store
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react"

export const api = createApi({
  reducerPath: "api",
  baseQuery: fakeBaseQuery(),
  endpoints: () => ({}),
  tagTypes: [
    "Auth",
    "Profile",
    "AllProfiles",
    "Vehicle",
    "AllVehicles",
    "VehicleModels",
    "Cart",
    "Payments",
    "Orders",
    "DriversLicense",
    "Wallet",
    "Tenants",
    "Email",
    "AppMails",
    "AppNotifications",
    "Analytics",
    "Expenses",
  ],
})
